import { AuthService } from 'src/app/modules/auth/auth.service';
import { Component, ElementRef, Input, OnInit } from '@angular/core';

import { Broadcaster } from 'src/utils/broadcaster.service';


@Component({
  selector: "app-drawer-menu",
  templateUrl: "./drawer-menu.component.html",
  styleUrls: ["./drawer-menu.component.css"]
})
export class DrawerMenuComponent implements OnInit{
  menuObject = [
    {
      name: "Home",
      permission: 1,
      icon: "home",
      link: "/home"
    },
    {
      name: "Leilões",
      permission: 1,
      icon: "gavel",
      link: "",
      submenu: [
        { name: "Novo leilão", permission: 1, link: "/category/detail" },
        { name: "Listar leilões", permission: 1, link: "/category/list" }
      ]
    },
    {
      name: "Cavalos",
      permission: 1,
      icon: "category",
      link: "",
      submenu: [
        { name: "Novo cavalo", permission: 1, link: "/product/detail" },
        { name: "Listagem cavalos", permission: 1, link: "/product/list" }
      ]
    },
    {
      name: "Produtos",
      permission: 1,
      icon: "class",
      link: "",
      submenu: [
        { name: "Novo produto", permission: 1, link: "/accessory/detail" },
        { name: "Listagem produtos", permission: 1, link: "/accessory/list" }
      ]
    },
    {
      name: "Lotes",
      permission: 1,
      icon: "style",
      link: "",
      submenu: [
        { name: "Novo lote", permission: 1, link: "/lot/detail" },
        { name: "Listagem de lotes", permission: 1, link: "/lot/list" }
      ]
    },
    {
      name: "Usuários",
      permission: 1,
      icon: "people",
      link: "",
      submenu: [
        { name: "Novo usuário", permission: 1, link: "/user/detail" },
        { name: "Listagem de usuários", permission: 1, link: "/user/list" }
      ]
    },
    // {
    //   name: "Classified",
    //   permission: 1,
    //   icon: "list",
    //   link: "",
    //   submenu: [
    //     { name: "New Classified", permission: 1, link: "classified/detail" },
    //     { name: "Classified List", permission: 1, link: "classified/list" },
    //     { name: "Classified for test", permission: 1, link: "" }
    //   ]
    // },
    {
      name: "SMS",
      permission: 1,
      icon: "sms",
      link: "",
      submenu: [
        { name: "SMS", permission: 1, link: "/sms/detail" },
        { name: "Listagem de SMS", permission: 1, link: "/sms/list" }
      ]
    },
    {
      name: "Páginas",
      permission: 1,
      icon: "receipt",
      link: "",
      submenu: [
        { name: "Termos & condições", permission: 1, link: "/pages/terms" },
        { name: "Sobre nós", permission: 1, link: "/pages/about-us" },
        { name: "Fale conosco", permission: 1, link: "/pages/contact-us" },
        { name: "Privacidade", permission: 1, link: "/pages/privacy" },
        { name: "Serviços", permission: 1, link: "/pages/services" },
        { name: "Como funciona", permission: 1, link: "/pages/how-it-works" },
        { name: "Como funciona (Classificados)", permission: 1, link: "/pages/how-it-works-classified" },
        { name: "Frete", permission: 1, link: "/pages/freight" }
      ]
    },
    {
      name: "Banners",
      submenu: [
        { name: "Novo banner", permission: 1, link: "/banner/detail" },
        { name: "Listagem de banners", permission: 1, link: "/banner/list" }
      ],
      permission: 1,
      icon: "picture_in_picture",
      link: ""
    },
    // {
    //   name: "Publicity",
    //   permission: 1,
    //   icon: "chrome_reader_mode",
    //   link: "",
    //   submenu: [
    //     { name: "New publicity", permission: 1, link: "" },
    //     { name: "Publicity list", permission: 1, link: "" }
    //   ]
    // },
    {
      name: "Virtual",
      submenu: [
        { name: "Gerenciar", permission: 1, link: "/category/virtual" },
      ],
      permission: 1,
      icon: "live_tv",
      link: ""
    },
    {
      name: "Acompanhamento",
      permission: 1,
      icon: "live_tv",
      link: "",
      submenu: [
        // { name: "Monitoring", permission: 1, fixedLink: "https://xrleiloes.com.br/cache_stat.php" },
        // { name: "Acompanhar Antigo", permission: 1, link: "", fixedLink: 'https://panel.xrleiloes.com.br/dashboard.html'},
        { name: "Acompanhar", permission: 1, link: "", fixedLink: 'https://acompanhamento.xrleiloes.com.br'},
        // { name: "Application form", permission: 1, fixedLink: "https://xrleiloes.com.br/application_form.php" }
      ]
    },
    {
      name: "Relatórios",
      permission: 1,
      icon: "subject",
      link: "",
      submenu: [
        { name: "Por lote", permission: 1, link: "/reports/by-lot" },
        { name: "Por usuário", permission: 1, link: "/reports/by-user" },
        { name: "Lances por leilão", permission: 1, link: "/reports/by-category" }
      ]
    },
    {
      name: "Usuários admin",
      permission: 1,
      icon: "how_to_reg",
      link: "",
      submenu: [
        { name: "Novo usuário", permission: 1, link: "/admin/detail" },
        { name: "Listagem de usuários", permission: 1, link: "/admin/list" },
    ]
    },
    {
      name: "Indicacoes",
      permission: 1,
      icon: "people_outline",
      link: "",
      submenu: [
        { name: "Listagem de indicacoes", permission: 1, link: "/referral/list" },
      ]
    },
    // {
    //   name: "About",
    //   permission: 1,
    //   icon: "notification_important",
    //   link: ""
    // },
  ];

  @Input()
  drawer = this;
  isOpen = false;
  constructor(
    private elRef: ElementRef,
    private broadcaster: Broadcaster,
    private authService: AuthService
    ) {}
  ngAfterViewInit() {
    var menu = document.getElementById("menu");

    menu.addEventListener("click", e => {
      let el = e.target as HTMLElement;
      let ul = el.closest("li").querySelector("ul");
      if (ul) {
        ul.classList.toggle("show-submenu");
      }else{
        this.isOpen = false;
      }
    });
  }
  logout(){
    this.authService.logout();
  }
  setDrawerClosed(){
    this.isOpen = false;
  }
  ngOnInit(){
    this.broadcaster.on('openMenu').subscribe(()=>{
      this.isOpen = !this.isOpen;
    })
  }

}
